import React from 'react';

import { MCButton, Spinner } from 'src/components/basic';

import {
  countFormat,
  lang,
  permissions,
  upperFirstCharAll,
  userFullName,
  withRouter
} from 'src/helpers';

import model from './model';
import { Map } from 'src/components/complex';
import moment from 'moment';
import LANG_CONST from 'src/helpers/lang/const';
import constants from 'src/constants';
import AlertManager from 'src/components/alert';

class CenterDetail extends React.PureComponent {
  checkDisabledDoctor = async (doctor) => {
    try {
      if (constants.general.userStatus.disabled === model.state.user?.status) {
        model.emit('checkDisabledAccount', model.state.user);
        return true;
      }

      return new Promise((resolve) =>
        model.api('doctor_detail', { username: doctor.username }, (error, res) => {
          if (!error && res.status === constants.general.userStatus.disabled) {
            AlertManager.popup(AlertManager.TYPES.INFO, {
              maxWidth: 450,
              close: false,
              title: model.state.user?.isPatient
                ? doctor.role?.includes('_') && doctor.clinicName
                  ? lang.t(LANG_CONST.notice.disabled_clinic_doctor, {
                      clinic: upperFirstCharAll(doctor.clinicName),
                      doctor: upperFirstCharAll(userFullName(doctor))
                    })
                  : lang.t(LANG_CONST.notice.disabled_doctor, {
                      doctor: upperFirstCharAll(userFullName(doctor))
                    })
                : lang.t(LANG_CONST.notice.disabled_doctor_for_clinic, {
                    doctor: upperFirstCharAll(userFullName(doctor))
                  }),
              actionButton: {
                label: LANG_CONST.buttons.ok,
                action: (props) => props.hide()
              }
            });
            resolve(true);
          }
          resolve(false);
        })
      );
    } catch (e) {
      model.log('checkDisabledDoctor error', e);
    }

    return false;
  };

  render() {
    const doctor = this.props.detail || this.props;
    if (!doctor.id) return null;
    let haveAvailableSlots = model.haveAvailableSlots();
    let { bookFlg, booked } = model.getState();
    let bookButtonText = 'Book an Appointment';

    if (!bookFlg && !haveAvailableSlots) {
      bookButtonText = 'No available time';
    } else if (booked) bookButtonText = 'Booked';
    let slotsLoading = model.getApiState('getAvailableSlots').loading;
    let showBookedBtn =
      !this.props.isAdminPage &&
      (model.state.user?.isPatient ||
        (!model.state.user?.isDoctor &&
          doctor.role === 'doctor_' + model.state.user?.managerToClinic));

    let experience = doctor.yearOfStarting
      ? moment().year() - doctor.yearOfStarting + 1
      : doctor.training;
    if (experience > 0) {
      experience = lang.t(experience > 1 ? LANG_CONST.amount_years : LANG_CONST.amount_year, {
        amount: experience
      });
    }
    const hospitalAddress = [doctor.hospitalName?.split('_')[0], doctor.hospitalAddress]
      .filter((v) => !!v)
      .join(', ');

    return (
      <div className={'mc-content-right'}>
        {showBookedBtn && slotsLoading && <Spinner />}
        {showBookedBtn && !slotsLoading && (
          <MCButton
            dark
            medium
            primary
            radius
            disabled={!haveAvailableSlots || booked}
            onClick={async () => {
              if (await this.checkDisabledDoctor(doctor)) return;
              if (haveAvailableSlots) {
                this.props.router.navigate(
                  model.state.user?.isPatient
                    ? permissions.PAGES.APPOINTMENTS_BOOK_PAGE.match(doctor?.username)
                    : permissions.PAGES.APPOINTMENTS_CREATE_PAGE.path,
                  {
                    state: { slot: { ...model.state.availableSlots[0], userId: doctor.id } }
                  }
                );
              }
            }}
          >
            {bookButtonText}
          </MCButton>
        )}

        <div className={'mc-box'}>
          <div className={'mc-flex'}>
            <div className={'mc-title'}>
              <div className={'mc-label'}>{lang.t('Total')}</div>
              {lang.t('Treatments')}
            </div>
            <div className={'mc-value'}>{countFormat(doctor.treatmentCount)}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-title'}>
              <div className={'mc-label'}>{lang.t('Total')}</div>
              {lang.t('Patients')}
            </div>
            <div className={'mc-value'}>{countFormat((doctor.patientIds || [])?.length)}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-title'}>
              <div className={'mc-label'}>{lang.t('Total')}</div>
              {lang.t('Experience')}
            </div>
            <div className={'mc-value'}>{experience}</div>
          </div>
        </div>

        <div className={'mc-box'}>
          <div className={'mc-flex-col'}>
            <div className={'mc-title'}>{lang.t('Clinic / Hospital')}</div>
            <div className={'mc-label'}>{hospitalAddress}</div>
            <Map addressString={doctor.hospitalAddress} geocode={true} width={300} height={300} />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CenterDetail);
